import { Checkbox, FormControlLabel, FormControlLabelProps, styled } from "@mui/material";
import type { JSX } from "react";

interface CheckboxFieldProps extends Omit<FormControlLabelProps, "control"> {
  checked: boolean;
  name: string;
}

type StyledCheckboxFieldProps = {
  checkedState: boolean;
};

const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "checkedState",
})<StyledCheckboxFieldProps>(({ theme, checkedState }) => ({
  ...((theme.components?.CheckboxField?.styleOverrides?.root?.({
    ownerState: { checked: checkedState },
    theme,
  }) as object) || {}),
}));

export const CheckboxField = ({ checked, onChange, name, label, ...props }: CheckboxFieldProps): JSX.Element => {
  return (
    <StyledFormControlLabel
      checkedState={checked}
      control={<Checkbox checked={checked} name={name} sx={{ p: 0 }} />}
      label={label}
      name={name}
      onChange={onChange}
      {...props}
    />
  );
};
